import React, { useState } from "react";
import toast from "react-hot-toast";
import "../App.css";
import Logo from "../assets/images/PAYLOFT_LOGO.png";
import { resetPasswordRequest } from "../services/onboarding";
import { ReactComponent as Spinner } from "../assets/icons/spinner.svg";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const resetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await resetPasswordRequest(email);
      toast.success(res.message);
      setLoading(false);
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="flex justify-center">
      <div className="w-[448px] p-4">
        <div className="flex items-center justify-center">
          <img src={Logo} alt="logo" className="w-full h-auto" />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-20 text-center">
          Reset Password
        </h1>
        <div className="mt-4">
          <form onSubmit={resetPassword}>
            <div className="flex flex-col">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                placeholder="example@gmail.com"
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mt-20">
              <button
                className="bg-text-orange text-white w-[415px] h-[50px] rounded-md"
                type="submit"
              >
                {loading ? (
                  <div className="spinner">
                    <Spinner />
                  </div>
                ) : (
                  "Reset Password"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
